import React from 'react';

import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { NavLink } from "react-router-dom";
import { USER_INIT, ARTICLE_INIT, BIASSE_INIT } from '../constants/globals';
import { updateCdesLignes } from '../actions/actions-types';


const MonPanier = (props) => {
    const { userCJ } = useSelector(state => state);
    const dispatch = useDispatch()
    const [producteurs, setProducteurs] = useState([]);
    const [fiche, setFiche] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [articles, setArticles] = useState([]);
    const [cdesLignes, setCdesLignes] = useState([]);
    const [biasse, setBiasse] = useState([]);
    const [maj, setMaj] = useState(false);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        majPanier()
    }, []); 

    useEffect(() => {
        const articles = [];
        articles.push(ARTICLE_INIT);
        setArticles(articles);
    }, []);

    useEffect(() => {
        setFiche(false);
    }, []);

    useEffect(() => {
        setSelectedProduct(USER_INIT);
    }, []);

    function findIndex(idStr) {
        const idArray = idStr.split('_');
        return Number(idArray[1]);
    };


    function majPanier() {
        fetch(`${URL_COURTJUS_BACK}/biasseactive`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res === null) {
                    const newBiasse = BIASSE_INIT;
                    newBiasse.cmdOpen = false;
                    setBiasse(newBiasse);
                } else {
                    const dateNow = new Date();
                    const dateB = new Date(res.bDate.substring(0, 10));
                    const dateBCI = new Date(res.bDateCdeIni.substring(0, 10));
                    const dateBCE = new Date(res.bDateCdeEnd.substring(0, 10));
                    dateBCE.setDate(dateBCE.getDate() + 1);
                    let lignes = []
                    if (dateBCI <= dateNow && dateBCE >= dateNow) { res.cmdOpen = true } else { res.cmdOpen = false };
                    res.bDate = dateB.toLocaleDateString();
                    res.bDateCdeIni = dateBCI.toLocaleDateString();
                    res.bDateCdeEnd = dateBCE.toLocaleDateString();
                    setBiasse(res);
                    fetch(`${URL_COURTJUS_BACK}/cdeslignes/${userCJ.uNum}_${res.bNum}`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(resC => {
                            lignes = resC
                            setCdesLignes(resC);
                        });
                    fetch(`${URL_COURTJUS_BACK}/producteurs`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(resP => {
                            const producteurs = []
                            const participants = res.bParticipants.split(',')
                            resP.forEach(unit => {
                                const found = participants.find(element => String(element) === String(unit.uNum));
                                if (found) {
                                    // Check if the unit has at least one CdesLignes
                                    if (lignes.some(lignesC => lignesC.cProducteur === unit.uNum)) {
                                        let lstArticlesCde = ''
                                        const filteredCdesLignes = lignes.filter(unitC => unitC.cProducteur === unit.uNum);
                                        filteredCdesLignes.forEach(unitC => {
                                            lstArticlesCde += unitC.aLibelle + '|';
                                        });
                                        lstArticlesCde = lstArticlesCde.slice(0, -1);
                                        unit.uInfosComp = lstArticlesCde
                                        producteurs.push(unit)
                                    }
                                }
                            });

                            setProducteurs(producteurs);
                        });
                }
            });
    }; 


    function euros(NumValue) {
        const retour = Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(NumValue,);
        return retour;
    };

    function unitemesure(UnitNb, Mesure) {
        let retour = '';
        let mesureTxt = Mesure
        let nombreTxt = UnitNb
        if (UnitNb > 1 && Mesure !== 'Colis') { mesureTxt = mesureTxt + 's' }
        let femminin = ['Pièce', 'Demie Pièce', 'Bouteille']
        if (UnitNb === 1 && femminin.includes(Mesure)) { nombreTxt = 'la ' }
        if (UnitNb === 1 && !femminin.includes(Mesure)) { nombreTxt = 'le ' }
        if (UnitNb > 1) { nombreTxt = 'les ' + UnitNb }
        retour = nombreTxt + " " + mesureTxt
        return retour;
    };

    const handleChangeArticle = (event) => {
        event.preventDefault();
        const { id, name, value } = event.target;
        const articlesChange = [...articles];
        articlesChange[findIndex(id)][name] = value;
        articlesChange[findIndex(id)].aMsg = "";
        setArticles(articlesChange);
    };

    let secuUpdate = true;
    if ((userCJ.uNum > 0 && biasse.cmdOpen)) { secuUpdate = false };

    const handleView = (event) => {
        const { name } = event.target;
        fetch(`${URL_COURTJUS_BACK}/users/${name}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res === null) {
                    setSelectedProduct(USER_INIT);
                } else {
                    setSelectedProduct(res[0]);
                }
                fetch(`${URL_COURTJUS_BACK}/articlesenventes/${res[0].uNum}`, {
                    method: 'GET',
                    headers: headers,
                })
                    .then(response => response.json())
                    .then(resA => {
                        const filteredArticles = resA.filter(article => {
                            const found = cdesLignes.find(element => element.cArticle === article.aNum);
                            if (found) {
                                article.cid = found._id
                                article.cBiasse = found.cBiasse
                                article.cProducteur = Number(name)
                                article.cUser = found.cUser
                                article.cArticle = found.cArticle
                                article.cNombre = found.cNombre
                                article.cNombreIni = found.cNombre
                                article.cCommentaire = found.cCommentaire
                                article.CArticleLib = found.CArticleLib
                                return true;
                            } else {
                                return false;
                            }
                        });
                        setArticles(filteredArticles);
                    });
            });
        setFiche(true);
    };

    const handleHide = (event) => {
        setSelectedProduct(USER_INIT);
        setArticles([])
        setFiche(false);
        setMaj(false);
        if (maj) {majPanier()}; 
};

    const handleSubmit = (event) => {
        event.preventDefault();
        const { id } = event.target;
        const actArticle = articles[findIndex(id)];
        let errMsg = "";
        if (isNaN(actArticle.cNombre)) {
            errMsg = "le nombre n'est pas valide !";
        };
        if ((Number(actArticle.reste) + Number(actArticle.cNombreIni) - Number(actArticle.cNombre)) < 0) {
            errMsg = "Le nombre demandé dépasse le stock !";
        };
        if ((Number(actArticle.cNombre)) < 0) {
            errMsg = "Le nombre demandé est inferieur à 0 !";
        };
        if (errMsg) {
            const articlesChange = [...articles];
            articlesChange[findIndex(id)].aMsg = errMsg;
            setArticles(articlesChange);
        };
        if (!errMsg) {
            // Ajout modification d'une ligne de commande
            dispatch(updateCdesLignes({ actArticle }));
            errMsg = "Commande actualisée !";
            const articlesChange = [...articles];
            articlesChange[findIndex(id)].aMsg = errMsg;
            setArticles(articlesChange);
            setTimeout(() => {
                fetch(`${URL_COURTJUS_BACK}/cdeslignes/${userCJ.uNum}_${biasse.bNum}`, {
                    method: 'GET',
                    headers: headers,
                })
                    .then(response => response.json())
                    .then(resC => {
                        setCdesLignes(resC);
                    });
            }, 2000);

        }
        setMaj(true);
    };

    const handleDelete = (event, index) => {
        event.preventDefault();
        const articlesChange = [...articles];
        articlesChange[index].cNombre = 0;
        setArticles(articlesChange);
        handleSubmit(event);
    };

    return (
        <main className="container">
            <div className="main-down"></div>
            <section className='main-title'><p>Mes commandes pour le {biasse.bDate} - {biasse.bLibelle}</p>
            </section>
            {userCJ.uNum < 1 && <section className="section-prods-err"><p>Veuillez vous authentifier !</p></section>}
            {producteurs.map((q, i) =>
                <section className="section-prods section-auto" key={i}>
                    <NavLink aria-label="voir les articles" title="voir les articles" onClick={handleView}><img name={`${q.uNum}`} className="btn-articles" src="/img/shopping_check.png" alt="Voir les articles" /></NavLink>
                    <article className="section-prods-fiche">
                        <h2>{q.uStructure}  <span className="p-impact">{q.uProduction}</span></h2>
                        <p> {q.uTel}</p>
                        <div className="btn-detail">
                        </div>
                    </article>
                    <div>
                        {q.uInfosComp.split('|').map((r, j) =>
                            <div className='biasse-list-particip' style={{ width: '95%' }} key={j}><p>{r}</p></div>
                        )}
                    </div>
                </section>
            )}
            {fiche &&
                <div className='zone-fiche-fixed'>
                    <article>
                        <h2><NavLink aria-label="Retour Liste" title="Retour à la liste" onClick={handleHide}><img className="btn-retour" src="/img/retour.png" alt="retour à la liste" /></NavLink>
                            {selectedProduct.uStructure} <span className="span-light">({selectedProduct.uNum})</span>  <span className="p-impact">{selectedProduct.uProduction}</span></h2>

                        <h3>{selectedProduct.uPrenom} {selectedProduct.uNom}</h3>
                        <p>{selectedProduct.uMailPro && selectedProduct.uMailPro}{selectedProduct.uMailPro === "" && selectedProduct.uMail} - {selectedProduct.uTel} - {selectedProduct.uAdr_CP} {selectedProduct.uAdr_Ville}</p>
                        <div className="btn-detail">

                        </div>
                    </article>
                    <article className="section-prods-infos form-fiche">
                        <fieldset>
                            <legend>Produits à la vente</legend>
                            {articles.map((q, i) =>
                                <form method="POST" id={`form_${i}`} key={i} disabled={secuUpdate} onSubmit={handleSubmit}>
                                    <div className={`form-zone form-zone-${secuUpdate && 'disabled'}`}>
                                        {q.aMsg && <section className="section-prods-err"><p>{q.aMsg}</p></section>}
                                        <p>
                                            <span className="zone-fiche-span p-impact">{q.aLibelle}</span>
                                            &nbsp;{q.aPrecision.length > 0 && <img src="img/bille.png" alt={q.aPrecision} title={q.aPrecision} />}&nbsp;
                                            <span className="zone-fiche-span-bold">{euros(q.aUnitPrice)}</span>
                                            {unitemesure(q.aUnitNb, q.aMesure)}
                                            <span className="zone-fiche-span-bold">[{Number(q.cNombre) >= 0 && (Math.round((Number(q.reste) + Number(q.cNombreIni) - Number(q.cNombre)) * 100) / 100) + " en stock"}
                                                {Number(q.cNombre) < 0 && (Number(q.reste)) + " en stock"} ]
                                            </span>
                                            <label htmlFor="cNombre"> Nb </label>&nbsp;
                                            <input className={`input-small ${q.cNombre > 0 ? 'input-vals' : ''}`} type="number" maxLength="5" name="cNombre" id={`cNombre_${i}`} required value={q.cNombre} onChange={handleChangeArticle} disabled={secuUpdate} />
                                            &nbsp;{!secuUpdate && <button id={`sav_${i}`} disabled={secuUpdate} className='btn btn-primary' style={{ marginRight: '0' }}>Enregistrer</button>}
                                            &nbsp;{!secuUpdate && <button id={`del_${i}`} disabled={secuUpdate} className='btn btn-outline-danger' style={{ marginRight: '0' }} type="button" title='Supprimer' onClick={(e) => handleDelete(e, i)}>X</button>}
                                            <br />
                                                {/* &nbsp;<label htmlFor="cCommentaire"> Infos Complementaire. </label>  */}
                                                &nbsp;<input className="input-infos input-dbl" title='Informations Complementaire (si besoin).' type="text" name="cCommentaire" id={`cCommentaire_${i}`} value={q.cCommentaire} onChange={handleChangeArticle} disabled={secuUpdate} />
                                        </p>
                                        <p style={{ display: 'none' }}> {q.aComment} </p>
                                    </div>
                                </form>
                            )}
                        </fieldset>
                    </article>
                    <article>
                        <h2><NavLink aria-label="Retour Liste" title="Retour à la liste" onClick={handleHide}><img className="btn-retour" src="/img/retour.png" alt="retour à la liste" /></NavLink></h2>
                    </article>
                </div>
            }
            <div className="main-down"></div>

        </main>

    )
}

export default MonPanier;